/**
 * Toggle switch component for enabling/disabling accounts
 */
import './Toggle.css';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
}

export function Toggle({ checked, onChange, disabled = false, label }: ToggleProps) {
  return (
    <label className={`toggle-wrapper ${disabled ? 'disabled' : ''}`}>
      <div className={`toggle ${checked ? 'on' : 'off'}`} onClick={() => !disabled && onChange(!checked)}>
        <div className="toggle-handle" />
      </div>
      {label && <span className="toggle-label">{label}</span>}
    </label>
  );
}
